import { Button } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { MaintenanceList } from "components/maintenance-list/maintenance-list";
import { Page } from "components/page";
import { usePropertyTenancy } from "contexts/property-tenancy-provider";
import { tenancyMaintenanceModel } from "modules/tenant-portal/models/maintenance";

export function MaintenanceScreen() {
  const { propertyTenancyId } = usePropertyTenancy();
  const { data, isLoading } = useQuery(
    tenancyMaintenanceModel.queries.list(propertyTenancyId),
  );

  return (
    <Page
      heading={"Maintenance"}
      rightElement={
        <Link to={"./request"}>
          <Button size={["sm", "md"]} colorScheme={"gray"} px={6} h={"36px"}>
            Request Maintenance
          </Button>
        </Link>
      }
    >
      <MaintenanceList
        isLoading={isLoading}
        maintenanceTasks={data?.data ?? []}
      />
    </Page>
  );
}
